import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useFireAgencyContext } from 'src/contexts/fire-agency.context';
import { IFireAgencyForm } from 'src/models/fire-agency.model';
import { getFireAgencyStatus } from 'src/selectors/fire-agency.selector';
import { actionTypes } from 'src/ducks/fire-agency.duck';
import style from '../fire-agencies-list/fire-agencies-list.module.scss';
import FireAgenciesForm from '../fire-agencies-form/fire-agencies-form.component';

const FireAgenciesAdd: React.FC = () => {
  const { state, actions } = useFireAgencyContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IFireAgencyForm> = {
    name: '',
    rate: 0,
    agencyId: 0,
  };

  const addStatus = getFireAgencyStatus(state, actionTypes.FIRE_AGENCY_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IFireAgencyForm = {
        name: data.name,
        rate: data.rate,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FIRE_AGENCY_ADD_SUCCESS,
            formData.name ? formData.name : data.name
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_FIRE_AGENCY}
      content={
        <div className={style.content}>
          <FireAgenciesForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FireAgenciesAdd;
